import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
   const [token, setTokenState] = useState(() => {
    return localStorage.getItem('token') || sessionStorage.getItem('token') || null;
  });

   const setToken = (newToken, rememberMe = false) => {
    setTokenState(newToken);

    if (rememberMe) {
      localStorage.setItem('token', newToken);
      sessionStorage.removeItem('token');
    } else {
      sessionStorage.setItem('token', newToken);
      localStorage.removeItem('token');
    }
  };

    const logout = () => {
    setTokenState(null);
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
  };

  useEffect(() => {
    if (token) {
      localStorage.setItem('token', token);
    } else {
      localStorage.removeItem('token');
    }
  }, [token]);

  return (
    <AuthContext.Provider value={{ token, setToken }}>
      {children}
    </AuthContext.Provider>
  );
};